/**
 * 何宽 2021.8.31
 * 根据 catid 和 glid 整理得到对应的层级关系
 */
const treeOrder = {
  TreeThree(arr)
  {
    let first = []
    let second = []
    let third = []

    // 筛选出第一级数据
    arr.forEach((item) =>
    {
      if (item.glid === 0)
      { // 修改为数字 0
        first.push({ value: item.id, label: item.dispc })
      }
    })

    // 筛选出第二级数据
    first.forEach((firstItem) =>
    {
      arr.forEach((item) =>
      {
        if (item.glid === firstItem.value)
        { // 修改为直接比较数字
          second.push({ value: item.id, label: '\xa0\xa0\xa0' + '|— ' + item.dispc })
        }
      })
    })

    // 筛选出第三级数据
    second.forEach((secondItem) =>
    {
      arr.forEach((item) =>
      {
        if (item.glid === secondItem.value)
        { // 修改为直接比较数字
          third.push({ value: item.id, label: '\xa0\xa0\xa0' + '| ' + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + '|— ' + item.dispc })
        }
      })
    })

    // 合并所有层级的数据
    return [...first, ...second, ...third]
  },
  TreeTow(arr)
  {
    let first = []
    let second = []
    // 筛选出第一级数据
    let temp = []
    arr.forEach((item) =>
    {
      if (item.glid === '0')
      {
        first.push({ value: item.id, label: item.dispc })
        temp.push(item.id)
      }
    })
    // 筛选出第二级数据
    for (let i = 0; i < first.length; i++)
    {
      second.push({ value: first[i].value, label: first[i].label })
      for (let j = 0; j < arr.length; j++)
      {
        if (parseInt(arr[j].glid) === first[i].value)
          second.push({ value: arr[j].id, label: '\xa0\xa0\xa0' + '|— ' + arr[j].dispc })
      }
    }
    return second
  },
  //矿业信息地图三级查询
  TreeThrees(arr)
  {
    let first = []
    let second = []
    let third = []
    // 筛选出第一级数据
    let temp = []
    arr.forEach((item) =>
    {
      if (item.glid === 0)
      {
        first.push({ value: item.id, label: item.namec })
        temp.push(item.id)
      }
    })
    // 筛选出第二级数据
    for (let i = 0; i < first.length; i++)
    {
      second.push({ value: first[i].value, label: first[i].label })
      for (let j = 0; j < arr.length; j++)
      {
        if (parseInt(arr[j].glid) === first[i].value)
          second.push({ value: arr[j].id, label: '\xa0\xa0\xa0' + '|— ' + arr[j].namec })
      }
    }
    // 筛选出第三级数据
    for (let i = 0; i < second.length; i++)
    {
      third.push({ value: second[i].value, label: second[i].label })
      for (let j = 0; j < arr.length; j++)
      {
        if (parseInt(arr[j].glid) === second[i].value && temp.indexOf(second[i].value) === -1)
          third.push({ value: arr[j].id, label: '\xa0\xa0\xa0' + '| ' + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + '|— ' + arr[j].namec })
      }
    }
    return third
  }
}
export default treeOrder



// WEBPACK FOOTER //
// ./src/plugins/backer/method/tree.js